import { CustomForm, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { RawMaterials } from "tilby-models";

export class RawMaterialsFe implements RawMaterials {
    id?: number = 0;
    name: string = "";
    cost?: number = 0;
    stock_type?: string = "";
    auto_unload?: boolean = false;
    quantity_alert?: number = 0;
    unit?: string = "";
    default_supplier_id?: number = 0;
}

export type RawMaterialsFields = RawMaterials;

export type RawMaterialsFieldsNullable = { [prop in string & keyof RawMaterialsFields]: RawMaterialsFields[prop] | null };
export type RawMaterialsForm = Partial<CustomForm<RawMaterialsFieldsNullable>>;

export type RawMaterialsFormGroups = CustomFormGroup<RawMaterialsForm>;

export interface RawMaterialsValidators extends ProvValidator {
    nameMaxLength: number;
    alertQuantityMinValue: number;
    unitMaxLength: number;
    costMinValue: number;
}

export const filterableRawMaterialsColumnsWithSearchBar: (keyof RawMaterialsFe)[] = ["name"];